import { addDoc, getDoc, setDoc, collection, doc } from "firebase/firestore";
import { db } from "../../../firebaseConfig";
import { getRelativeTime, getDateTime } from "../../utils/time";

let userID = null; // Initialize userID as null

export const setUserID = (id) => {
  userID = id;
};

export async function copyDocumentData(sourceDocID, targetDocID) {
  try {
    const sourceDocRef = doc(db, "pages", sourceDocID);
    const sourceDocSnap = await getDoc(sourceDocRef);

    if (sourceDocSnap.exists()) {
      const sourceData = sourceDocSnap.data();
      const targetDocRef = doc(db, "views", targetDocID);
      await setDoc(targetDocRef, sourceData, { merge: true });
    } else {
      console.log("Source document does not exist.");
    }
  } catch (error) {
    console.error("Error copying document data:", error);
  }
}

export async function createNewViewWithUniqueID(viewType, sourceDocID = null, navigate) {
  if (!userID) {
    console.error("No user ID available. Make sure the user is signed in.");
    return;
  }

  try {
    const newDoc = { createdBy: userID, createdAt: Date.now() };
    const newViewRef = await addDoc(collection(db, "views"), newDoc);
    const newViewID = newViewRef.id;

    if (sourceDocID) {
      await copyDocumentData(sourceDocID, newViewID);
    }

    navigate(`/views/${newViewID}`); // Navigate to the new view page
  } catch (error) {
    console.error("Failed to create a new view:", error);
  }
}

export async function duplicateView(viewID, collectionName, navigate) {
  if (!userID) {
    console.error("No user ID available. Make sure the user is signed in.");
    return;
  }

  try {
    const sourceDocRef = doc(db, collectionName, viewID);
    const sourceDocSnap = await getDoc(sourceDocRef);

    if (sourceDocSnap.exists()) {
      const sourceData = sourceDocSnap.data();

      const newDocData = {
        ...sourceData,
        createdBy: userID,
        title: `${sourceData.title || "Untitled"} (copy)`,
      };

      const newDocRef = await addDoc(collection(db, collectionName), newDocData);

      if (collectionName === "views") {
        navigate(`/views/${newDocRef.id}`); // Navigate to the new view page
      } else if (collectionName === "library") {
        window.location.reload();
      }
    } else {
      console.error("Source document to duplicate does not exist.");
    }
  } catch (error) {
    console.error("Failed to duplicate view:", error);
  }
}
